import IssuesHistory from "./IssuesHistory";

export default IssuesHistory;
